import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const el = document.querySelector('#itau-prestamos-form');
    el.scrollIntoView();
  }, [pathname]);

  return null;
}

export default ScrollToTop;
